import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: "What macOS versions are supported?",
    answer: "Bento requires macOS 14 (Sonoma) or later."
  },
  {
    question: "Does Bento work with multiple monitors?",
    answer: "Yes! Bento remembers your window positions across all connected displays. When you restore a workspace, each app goes back to exactly where you had it."
  },
  {
    question: "Which browsers support URL saving?",
    answer: "Currently, URL saving works with Google Chrome. We save your open tabs and restore them when you load a workspace."
  },
  {
    question: "Why a subscription?",
    answer: "If people like Bento, we have some exciting features planned for future releases. Your subscription helps us keep building and improving."
  },
];

function FAQAccordionItem({ item, isOpen, onToggle }: { 
  item: FAQItem; 
  isOpen: boolean; 
  onToggle: () => void;
}) {
  return (
    <div className="border-b border-gray-200">
      <button
        onClick={onToggle}
        className="w-full py-5 flex items-center justify-between text-left hover:text-gray-600 transition-colors"
      >
        <span className="text-base md:text-lg font-medium pr-4">{item.question}</span>
        <ChevronDown 
          className={`w-5 h-5 flex-shrink-0 text-gray-400 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`} 
        />
      </button>
      <div 
        className={`overflow-hidden transition-all duration-200 ease-out ${
          isOpen ? 'max-h-96 pb-5' : 'max-h-0'
        }`}
      >
        <p className="text-sm md:text-base text-gray-600 leading-relaxed">
          {item.answer}
        </p>
      </div>
    </div>
  );
}

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-20">
        <div className="max-w-[800px]">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light mb-4">
            Questions & Answers
          </h2>
          <p className="text-base md:text-lg text-gray-600 mb-12">
            Everything you need to know about Bento.
          </p>
          
          <div className="border-t border-gray-200">
            {faqs.map((faq, index) => (
              <FAQAccordionItem
                key={index}
                item={faq}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? null : index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

